import wrapError from "@/components/helpers/wrapError"

export const apiSendConfirmationEmails = (success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/sourcingConfirmationManager",
    success,
    error: wrapError(error, "apiSendConfirmationEmails"),
  })
}

export const apiRequeueNotSure = (success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/resetSourcingQueueManager",
    success,
    error: wrapError(error, "apiRequeueNotSure"),
  })
}

export const apiDownloadData = (params, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/dataDownloadManager",
    success,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    error: wrapError(error, "apiDownloadData"),
  })
}

export const apiGetFindEmailStats = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/sourcingStats",
    success,
    error: wrapError(error, "apiGetFindEmailStats"),
  })
}

export const apiGetDataHealthStats = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/dataHealth",
    success,
    error: wrapError(error, "apiGetDataHealthStats"),
  })
}

export const apiGetDataEnrichmentRequest = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/requestDataEnrichmentManager",
    success,
    error: wrapError(error, "apiGetDataEnrichmentRequest"),
  })
}

export const apiPostDataEnrichmentRequest = (success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/requestDataEnrichmentManager",
    success,
    error: wrapError(error, "apiPostDataEnrichmentRequest"),
  })
}

export const apiGetConstituentOptions = (query, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/admin/sourcingOptionsManager?query=${query}`,
    success,
    error: wrapError(error, "apiGetConstituentOptions"),
  })
}

export const apiUpdateConstituentOptions = (params, success, error) => {
  $.ajax({
    type: "PUT",
    url: "/api/admin/sourcingOptionsManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiUpdateConstituentOptions"),
  })
}

export const apiDownloadAllConstituents = (success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/dataDownloadManager",
    success,
    error: wrapError(error, "apiDownloadAllConstituents"),
  })
}
